export function calcMin(values: number[]): number {
  if (values.length == 0) return NaN;
  return values.reduce((res, cur) => (res > cur ? cur : res), Infinity); //note: we use reduce to allow for large array sizes!
}

export function calcMax(values: number[]): number {
  if (values.length == 0) return NaN;
  return values.reduce((res, cur) => (res < cur ? cur : res), -Infinity); //note: we use reduce to allow for large array sizes!
}

export function calcSum(values: number[]): number {
  return values.reduce((partialSum, item) => partialSum + item, 0);
}

export function calcAverage(values: number[]): number {
  if (values.length == 0) return NaN;
  return calcSum(values) / values.length;
}

export function calcStdev(values: number[]): number {
  const n = values.length;
  if (n == 0) return NaN;
  const average = calcAverage(values);
  if (values.length == 0) return NaN;
  return Math.sqrt(values.map((x) => (x - average) ** 2).reduce((a, b) => a + b, 0) / n);
}

export function calcQuantile(values: number[], quantile: number): number {
  if (values.length == 0) return NaN;
  const sorted = values.sort((a, b) => a - b);
  const pos = (sorted.length - 1) * quantile;
  const base = Math.floor(pos);
  const rest = pos - base;
  if (sorted[base + 1] !== undefined) {
    return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
  } else {
    return sorted[base];
  }
}
